import React from 'react';
import { Box } from '@mui/material';
import Calendar from './Calendar';

const CalendarSettings = ({ defaultSettings, onUpdateSettings }) => {
  return (
    <Box sx={{ mt: 4 }}>
      {defaultSettings?.calander && (
        <Calendar
          settings={defaultSettings.calander}
          onUpdateSettings={onUpdateSettings}
        />
      )}
    </Box>
  );
};

export default CalendarSettings;
